module.exports = __webpack_public_path__ + "components/signup-page/static/icon-eye--hide-8e014aa4ebe5bffa3223877d88ae8297.svg";